import React from 'react';
import { QuestionContextType } from '.';
import QuestionContext from './context';

const useQuestions = (): QuestionContextType => React.useContext(QuestionContext);

export { useQuestions };